import { render, staticRenderFns } from "./form-workspace-update.vue?vue&type=template&id=0507b71c&"
import script from "./form-workspace-update.vue?vue&type=script&lang=js&"
export * from "./form-workspace-update.vue?vue&type=script&lang=js&"
import style0 from "./form-workspace-update.vue?vue&type=style&index=0&id=0507b71c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports